import { styled, Typography, Tabs, Tab, Paper } from '@mui/material';
import { Colors } from '../../../styles/colors';

// Styled components
export const StyledTabs = styled(Tabs)({
    borderBottom: '1px solid #E5E7EB',
    '& .MuiTabs-indicator': {
        backgroundColor: Colors.BRAND_BLUE,
    },
});

export const StyledTab = styled(Tab)({
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    color: Colors.NEUTRAL_GRAY,
    '&.Mui-selected': {
        color: Colors.BRAND_BLUE,
    },
});

export const StyledDropzone = styled(Paper)({
    border: '2px dashed #D1D5DB',
    borderRadius: '8px',
    padding: '40px 20px',
    textAlign: 'center',
    backgroundColor: '#FAFBFC',
    cursor: 'pointer',
    '&:hover': {
        borderColor: Colors.BRAND_BLUE,
        backgroundColor: '#F8FAFF',
    },
});

export const StyledLabel = styled(Typography)({
    fontSize: '14px',
    fontWeight: 500,
    color: '#374151',
    marginBottom: '6px',
    display: 'block',
});

// Dialog styles
export const dialogPaperStyles = {
    borderRadius: '12px',
    maxWidth: '1200px',
    width: '90vw',
    height: '80vh',
    display: 'flex',
    flexDirection: 'column'
};

export const modalContentStyles = {
    padding: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
};

export const scrollableContentStyles = {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
};

// Header styles
export const headerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 3,
    borderBottom: '1px solid #E5E7EB',
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 1
};

export const headerTitleStyles = {
    fontWeight: 600,
    color: Colors.PRIMARY_DARK
};

export const headerIconStyles = {
    color: Colors.NEUTRAL_GRAY
};

// Section styles
export const sectionHeaderStyles = {
    fontWeight: 600,
    color: Colors.PRIMARY_DARK,
    mb: 2
};

export const formSectionStyles = {
    p: 3,
};

export const sideBySideSectionStyles = {
    p: 3,
    display: 'flex',
    gap: 4
};

export const flexOneStyles = {
    flex: 1
};

//Request type chips styles
export const requestTypeChipsStyles = {
    backgroundColor: Colors.BRAND_BLUE,
    color: 'white',
    borderRadius: '24px',
    height: '24px',
    fontSize: '12px',
    fontWeight: 500,
    border: 'none',
    '& .MuiChip-label': {
        px: 1.5,
        py: 0.5,
    },
};

// Button styles
export const buttonRowStyles = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1.5,
    p: 3,
    backgroundColor: '#FAFBFC',
    borderTop: '1px solid #E5E7EB',
    position: 'sticky',
    bottom: 0,
    zIndex: 1
};

export const csvButtonRowStyles = {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 1.5,
    mt: 3,
    pt: 3,
    borderTop: '1px solid #E5E7EB'
};

export const cancelButtonStyles = {
    px: 4,
    py: 1.25,
    borderRadius: '24px',
    color: '#374151',
    border: '1px solid #D1D5DB',
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
        backgroundColor: '#F9FAFB',
    }
};

export const submitButtonStyles = {
    px: 4,
    py: 1.25,
    borderRadius: '24px',
    backgroundColor: Colors.SYNTHETIC_BLACK,
    color: 'white',
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
        backgroundColor: '#0F1A3D',
    },
    '&:disabled': {
        backgroundColor: '#E5E7EB',
        color: '#9CA3AF',
    }
};

export const downloadButtonStyles = {
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 500,
    borderColor: Colors.BRAND_BLUE,
    color: Colors.BRAND_BLUE,
    '&:hover': {
        backgroundColor: '#F8FAFF',
        borderColor: Colors.BRAND_BLUE,
    }
};

export const disabledSelectStyles = {
    borderRadius: '8px',
    backgroundColor: '#F9FAFB',
};

// CSV upload styles
export const csvUploadSectionStyles = {
    p: 3
};

export const csvDownloadCenterStyles = {
    mb: 3,
    textAlign: 'center'
};

// Error styles with smooth transitions
export const errorTextStyles = {
    color: 'error.main',
    ml: 1,
    fontSize: '0.75rem',
    transition: 'all 0.2s ease-in-out',
    lineHeight: 1.2
};

// Field wrapper with transition for smooth error appearance
export const fieldWrapperStyles = {
    '& .error-container': {
        maxHeight: 0,
        overflow: 'hidden',
        transition: 'max-height 0.3s ease-in-out',
        '&.has-error': {
            maxHeight: '60px',
            mt: 0.5
        }
    }
};

// Stepper styles
export const stepperStyles = {
    mb: 4,
    '& .MuiStepLabel-label': {
        fontSize: '14px',
        fontWeight: 500,
    },
    '& .MuiStepLabel-label.Mui-active': {
        color: Colors.PRIMARY_DARK,
        fontWeight: 600,
    },
    '& .MuiStepLabel-label.Mui-completed': {
        color: Colors.SUCCESS_GREEN,
        fontWeight: 500,
    },
    '& .MuiStepIcon-root': {
        color: '#E5E7EB',
        '&.Mui-active': {
            color: Colors.SYNTHETIC_BLACK,
        },
        '&.Mui-completed': {
            color: Colors.SUCCESS_GREEN,
        },
    },
};

// Additional button styles for stepper
export const backButtonStyles = {
    px: 4,
    py: 1.25,
    borderRadius: '24px',
    color: '#374151',
    border: '1px solid #D1D5DB',
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
        backgroundColor: '#F9FAFB',
    }
};

// Content area that grows to fill space
export const formContentStyles = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
};                